import styled, { css } from 'styled-components';

export const Buttons = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonStyled = styled.button`
  height: 40px;
  box-sizing: border-box;
  background: #47b972;
  box-shadow: 0 1px 1px 0 #2f7a53;
  font-size: 20px;
  line-height: 0.75;
  width: 100%;
  border: 0;
  cursor: pointer;
  border-radius: 5px;
  color: #fff;
  transition: 0.3s all ease-out;
  &:hover {
    background: #2f9457;
  }

  ${(props) =>
    props.size === 'medium' &&
    css`
      height: 34px;
      line-height: 32px;
      border-radius: 10px;
      width: auto;
      padding: 0 6px;
      ${props.$square &&
      css`
        width: 34px;
        flex-shrink: 0;
      `}
    `}

  ${(props) =>
    props.size === 'small' &&
    css`
      border-radius: 10px;
      height: 30px;
      width: auto;
      padding: 0 6px;
      line-height: 30px;
      ${props.$square &&
      css`
        width: 30px;
        flex-shrink: 0;
      `}
    `}

  ${(props) =>
    props.$alignRight &&
    css`
      font-size: 14px;
      flex-grow: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      border-radius: 3px !important;
      span {
        display: block;
        line-height: 30px;
        /* line-height: 1; */
      }
      b {
        display: block;
        margin-left: 6px;
        font-weight: normal;
        font-size: 20px;
        /* line-height: 1; */
        width: 19px;
      }
    `}
`;
